import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMembers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5 12.767C1.5 11.732 1.911 10.74 2.642 10.009C3.374 9.278 4.366 8.867 5.4 8.867C6.434 8.867 7.426 9.278 8.158 10.009C8.889 10.74 9.3 11.732 9.3 12.767M10.203 9.773C10.686 9.595 11.204 9.536 11.714 9.602C12.224 9.667 12.711 9.855 13.133 10.149C13.554 10.443 13.899 10.834 14.137 11.29C14.375 11.746 14.5 12.252 14.5 12.767M3.017 5.617C3.017 5.93 3.078 6.24 3.198 6.529C3.318 6.818 3.493 7.081 3.715 7.302C3.936 7.523 4.199 7.699 4.488 7.819C4.777 7.938 5.087 8 5.4 8C5.713 8 6.023 7.938 6.312 7.819C6.601 7.699 6.864 7.523 7.085 7.302C7.307 7.081 7.482 6.818 7.602 6.529C7.722 6.24 7.783 5.93 7.783 5.617C7.783 4.985 7.532 4.378 7.085 3.931C6.638 3.484 6.032 3.233 5.4 3.233C4.768 3.233 4.162 3.484 3.715 3.931C3.268 4.378 3.017 4.985 3.017 5.617ZM9.359 6.917C9.359 7.434 9.564 7.93 9.93 8.296C10.296 8.661 10.792 8.867 11.309 8.867C11.826 8.867 12.322 8.661 12.688 8.296C13.054 7.93 13.259 7.434 13.259 6.917C13.259 6.399 13.054 5.904 12.688 5.538C12.322 5.172 11.826 4.967 11.309 4.967C10.792 4.967 10.296 5.172 9.93 5.538C9.564 5.904 9.359 6.399 9.359 6.917Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMembers;
